export const getUnitSelected = state => state.unitSelected.data

export const getProfile = state => state.user.profile
